import { Component, Input, OnChanges, AfterContentInit, SimpleChanges, ElementRef } from '@angular/core'

@Component({
    selector: 'app-expandable-content-container',
    styleUrls: ['expandable-content-container.scss'],
    templateUrl: 'expandable-content-container.html'
})
export class ExpandableContentContainerComponent implements OnChanges, AfterContentInit {
    @Input() previewSize = '130px'
    @Input() toggleButtonLabels: [string, string]
    @Input() buttonBottomOffset = '0px'
    loading = true
    contentIsLargerThanPreview = false
    originalPreviewSize: string
    activeButtonLabelIndex = 0
    activeButtonLabel: string
    isExpanded = false
  
    private defaultToggleButtonlabels: [string, string] = ['Show more', 'Show less'] 

    constructor(private element: ElementRef) {
        this.originalPreviewSize = this.previewSize
        this.toggleButtonLabels = !this.toggleButtonLabels ? this.defaultToggleButtonlabels : this.toggleButtonLabels
        this.activeButtonLabel = this.toggleButtonLabels[0]
    }

    ngAfterContentInit(): void {
        setTimeout(() => {
            if (this.element?.nativeElement?.offsetHeight > parseFloat(this.previewSize) + 50) {
                this.contentIsLargerThanPreview = true
            } 
            this.loading = false
        }, 100)
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.previewSize) {
            this.originalPreviewSize = this.previewSize
        }

        if (changes.toggleButtonLabels) {
            this.toggleButtonLabels = !this.toggleButtonLabels ? this.defaultToggleButtonlabels : this.toggleButtonLabels
        }

        this.activeButtonLabel = this.toggleButtonLabels[this.activeButtonLabelIndex]
    }

    expandContentToggle() {
        this.isExpanded = !this.isExpanded
        this.previewSize = this.isExpanded ? 'auto' : this.originalPreviewSize 
        this.activeButtonLabelIndex = this.isExpanded ? 1 : 0
        this.activeButtonLabel = this.toggleButtonLabels[this.activeButtonLabelIndex]
    }
}
